<template>
	<div id="register">
		<HeaderTop></HeaderTop>
		<HeaderTitle :pageName="pagename" :topType="toptype"></HeaderTitle>
		<div class="word content">
			<div class="regist-box">
				<div class="top-list">
					<span class="title">{{$t('register.forget')}}</span>
				</div>
				<div class="handle-box">
					<div class="line">
						<span class="name"><em>*</em>{{$t('register.mailbox')}}：</span>
						<div class="inp" :class="{'faul' : isEmail }">
							<input type="text" v-model="email">
						</div>
						<div class="send">
							<span @click="send" v-if="sendMsg">{{$t('register.SendCode')}}</span>
							<span class="timer" v-else>{{timer}}{{$t('register.sendout')}}</span>
						</div>
						<div class="wrong-msg" v-if="isEmail">
							<div class="img"><img src="@/assets/images/wrong.png" alt=""></div>
							{{$t('register.Pleaseentermailbox')}}
						</div>
					</div>
				</div>
				<div class="handle-box">
					<div class="line">
						<span class="name"><em>*</em>{{$t('register.mailboxCode')}}：</span>
						<div class="inp" :class="{'faul' : isEmailCode }">
							<input type="text" v-model="emailCode">
						</div>
						<div class="wrong-msg" v-if="isEmailCode">
							<div class="img"><img src="@/assets/images/wrong.png" alt=""></div>
							{{$t('register.PleaseentermailboxCode')}}
						</div>
					</div>
				</div>

				<div class="handle-box">
					<div class="line">
						<span class="name"><em>*</em>{{$t('register.password')}}：</span>
						<div class="inp" :class="{'faul' : isPassword }">
							<input type="password" v-model="password">
						</div>
						<div class="wrong-msg" v-if="isPassword">
							<div class="img"><img src="@/assets/images/wrong.png" alt=""></div>
							{{$t('register.Pleaseenterpassword')}}
						</div>
					</div>
				</div>

				<div class="handle-box">
					<div class="line">
						<span class="name"><em>*</em>{{$t('register.Reconfirm')}}：</span>
						<div class="inp" :class="{'faul' : isRepassword }">
							<input type="password" v-model="repassword">
						</div>
						<div class="wrong-msg" v-if="isRepassword">
							<div class="img"><img src="@/assets/images/wrong.png" alt=""></div>
							{{$t('register.Pleasereconfirm')}}
						</div>
					</div>
				</div>

				<div class="btn-line">
					<div class="handle-click" @click="register">{{$t('register.modify')}}</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>

</template>

<script>
	import HeaderTop from '../assembly/HeaderTop'
	import HeaderTitle from '../assembly/HeaderTitle'
	import Footer from '../assembly/Footer'

	export default {
		name: 'register',
		data() {
			return {
				radio: 0,
				pagename: '',
				toptype: 'none',
				timer: 60,
				sendMsg: true, //是否显示发送验证码
				name: '',
				password: '',
				surname: '',
				phone: '',
				email: '',
				repassword: '',
				country: '',
				mechanismName: '',
				provinces: '',
				emailCode: '',

				isName: false,
				isSurname: false,
				isPassword: false,
				isPhone: false,
				isEmail: false,
				isRepassword: false,
				isCountry: false,
				isMechanismName: false,
				isProvinces: false,
				isEmailCode: false
			}
		},
		created() {
			this.pagename = this.$t('register.forget')
		},
		methods: {
			agree(e) {

			},
			register() {
				if (this.password == '') {
					this.isPassword = true
				} else {
					this.isPassword = false
				}
				if (this.email == '') {
					this.isEmail = true
				} else {
					this.isEmail = false
				}
				if (this.repassword == '' || this.repassword != this.password) {
					this.isRepassword = true
				} else {
					this.isRepassword = false
				}
				if (this.emailCode == '') {
					this.isEmailCode = true
				} else {
					this.isEmailCode = false
				}
				if (!this.isEmailCode && !this.isPassword && !this.isEmail && !this.isRepassword) {
					let url = '/open/user/forgetPwd/save'
					let params = {
						mail: this.email,
						password: this.password,
						code: this.emailCode
					}
					this.$post(url, params)
						.then((res) => {
							if (res.code == 0) {
								this.$message({
									message: this.$t('Tips.modifysuc'),
									type: 'success'
								});
								setTimeout(() => {
									this.$router.push('/login')
								}, 1000)
							}
						});
				} else {

				}
			},
			login() {
				this.$router.push('/login')
			},
			//发送验证码
			send() {
				if (this.email == '') {
					this.$message({
						message: this.$t('Tips.mailbox'),
						type: 'error'
					});
				} else {
					let url = '/open/user/forgetPwdSendMail'
					let data = {
						mailAddress: this.email
					}
					this.$get(url, data).then(res => {
						if (res.code == 0) {
							this.$message({
								message: this.$t('Tips.code'),
								type: 'success'
							});
							this.sendMsg = false
							let timerFn = setInterval(() => {
								if (this.timer != 0) {
									this.timer--
								} else {
									this.timer = 0;
									this.sendMsg = true
									clearInterval(timerFn)
								}
							}, 1000)
						} else {
							return
						}

					})
				}
			}
		},
		components: {
			HeaderTop,
			HeaderTitle,
			Footer
		},


	};
</script>

<style scoped>
	#register {
		width: 100%;
		min-height: 100vh;
		background: #fff;
	}

	.content {
		padding: 84px 0 102px 0;
		box-sizing: border-box;
	}

	.regist-box {
		width: 980px;
		box-sizing: border-box;
		padding: 0 30px;
		margin: 0 auto;
		border: 1px solid #E2E2E2;
		padding-bottom: 59px;
	}

	.top-list {
		font-weight: bold;
		height: 77px;
		border-bottom: 1px solid #E2E2E2;
		justify-content: space-between;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		margin-bottom: 55px;
	}

	.title {
		font-size: 26px;
		color: #1A1A1A;
	}

	.login {
		font-size: 17px;
		color: #379AE6;
	}

	.handle-box {
		padding-bottom: 24px;
		padding-left: 97px;
		box-sizing: border-box;
	}

	.lo {
		border-bottom: 1px solid #379AE6;
	}

	.line {
		display: flex;
		align-items: center;
		font-size: 15px;
	}

	.name {
		color: #1A1A1A;
		width: 180px;
		text-align: left;
	}

	em {
		color: #EE3220;
		margin-right: 7px;
	}

	.inp {
		width: 420px;
		height: 32px;
		border: 1px solid #E2E2E2;
		border-radius: 3px;
		overflow: hidden;
		box-sizing: border-box;
	}

	input {
		width: 100%;
		height: 100%;
		display: block;
		margin: 0;
		padding: 0;
		background: transparent;
		padding-left: 10px;
		box-sizing: border-box;
	}

	.wrong-msg {
		font-size: 15px;
		color: #EE3220;
		margin-left: 15px;
		display: flex;
		align-items: center;
	}

	.img {
		width: 20px;
		height: 20px;
	}

	.img img {
		width: 100%;
		height: 100%;
		display: block;
	}

	.btn-line {
		padding-left: 196px;
	}

	.handle-click {
		width: 420px;
		height: 36px;
		background-image: linear-gradient(#3F9FEA, #0573CB);
		line-height: 36px;
		text-align: center;
		font-size: 15px;
		color: #fff;
		border-radius: 3px;
	}

	.circle {
		width: 18px;
		height: 18px;
		border-radius: 50%;
		border: 1px solid #CACACA;
		box-sizing: border-box;
		margin-right: 6px;
	}

	.treaty {
		margin-top: 21px;
		display: flex;
		justify-content: left;
		align-items: center;
		font-size: 15px;
		color: #666666;
	}

	.faul {
		background: #ECECEC;
	}

	.send {
		height: 100%;
		background-image: linear-gradient(#3F9FEA, #0573CB);
		color: #fff;
		text-align: center;
		line-height: 30px;
		margin-left: 10px;
		padding: 0 10px;
	}

	.send span {
		display: block;
	}
</style>



// WEBPACK FOOTER //
// src/components/modifyPsd/modifyPsd.vue